import { Nullable } from "../models/Nullable"
import { isNumber } from "./isNumber"

export function calculateDiscountPercentage({
    finalPrice,
    manualPrice,
    discount,
}: {
    finalPrice: number,
    manualPrice?: Nullable<number>,
    discount?: Nullable<number>
}) {
    if (!isNumber(discount)) {
        return 0
    }
    if (isNumber(manualPrice)) {
        return Math.round((discount / manualPrice) * 100)
    }
    return Math.round((discount / (finalPrice + discount)) * 100)
}

export function calculateDiscountFromPercentage({
    subTotal,
    manualPrice,
    discountPercentage,
}: {
    subTotal: number,
    manualPrice?: Nullable<number>,
    discountPercentage: number
}) {
    if (isNumber(manualPrice)) {
        return manualPrice * (discountPercentage / 100)
    }
    return subTotal * (discountPercentage / 100)
}


export function calculateFinalPrice({
    subTotal,
    manualPrice,
    discount
}: {
    subTotal: number,
    manualPrice?: Nullable<number>,
    discount?: Nullable<number>
}) {
    if (isNumber(manualPrice)) {
        return manualPrice
    }
    if (!isNumber(discount)) {
        return subTotal
    }
    return subTotal - discount
}
